<div class="container-fluid p-4 p-lg-5 bg-white d-flex flex-column align-items-center justify-content-center gap-4" style="min-height: 60vh;">
  <h4 class="fw-bold m-0 d-flex align-items-center gap-2">
    <img src="assets/Image/icons-donate/_donor-info.svg" alt="">
    {{ 'CAMPAIGN.RecurringConfirmation.Title' | translate }}
  </h4>

  <p class="text-center text-muted">
    {{ 'CAMPAIGN.RecurringConfirmation.Description' | translate }}
  </p>

  <ng-container *ngIf="summaryVm$ | async as vm">
    <don-checkout-summary [vm]="vm"></don-checkout-summary>
  </ng-container>

  <div class="loader-container">
    <app-loader></app-loader>
  </div>
</div>
